import {
  ClientUserActivityOmitEmailsAdminGrid,
  type ClientUserActivityOmitEmailsAdminApi
} from '@jarvis/platform-ui';
import { useMemo } from 'react';
import {
  createClientUserActivityOmitEmail,
  deleteClientUserActivityOmitEmail,
  listClientUserActivityOmitEmails,
  updateClientUserActivityOmitEmail
} from '../../../api/clientUserActivityOmitEmails';

export function ClientUserActivityOmitEmailsAdminPage() {
  const api = useMemo<ClientUserActivityOmitEmailsAdminApi>(
    () => ({
      list: listClientUserActivityOmitEmails,
      create: createClientUserActivityOmitEmail,
      update: updateClientUserActivityOmitEmail,
      delete: deleteClientUserActivityOmitEmail
    }),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <ClientUserActivityOmitEmailsAdminGrid
          api={api}
          stateStorageKey="webopsui:client-user-activity-omit-emails-grid"
        />
      </div>
    </div>
  );
}
